import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.sass';
import { Icon } from '../Icon/index.tsx';

/**
 * TODO: Remove when encore/anchro colors is done https://anchorfm.atlassian.net/browse/WHEEL-825
 * @deprecated Use the `LoadingIndicator` in @spotify-internal/encore-web
 */
const Spinner = ({ size, color, type }) => {
  return type === 'spoke' ? (
    <div
      className={styles.spinner}
      style={{
        height: `${size}px`,
        width: `${size}px`,
      }}
      data-testid="loadingSpinner"
    >
      <div className={styles.spinnerSpoke} style={{ backgroundColor: color }} />
      <div className={styles.spinnerSpoke} style={{ backgroundColor: color }} />
      <div className={styles.spinnerSpoke} style={{ backgroundColor: color }} />
      <div className={styles.spinnerSpoke} style={{ backgroundColor: color }} />
      <div className={styles.spinnerSpoke} style={{ backgroundColor: color }} />
      <div className={styles.spinnerSpoke} style={{ backgroundColor: color }} />
      <div className={styles.spinnerSpoke} style={{ backgroundColor: color }} />
      <div className={styles.spinnerSpoke} style={{ backgroundColor: color }} />
      <div className={styles.spinnerSpoke} style={{ backgroundColor: color }} />
      <div className={styles.spinnerSpoke} style={{ backgroundColor: color }} />
      <div className={styles.spinnerSpoke} style={{ backgroundColor: color }} />
      <div className={styles.spinnerSpoke} style={{ backgroundColor: color }} />
    </div>
  ) : (
    <Icon type="SpinnerIcon" fillColor={color} />
  );
};

Spinner.propTypes = {
  size: PropTypes.number,
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  type: PropTypes.oneOf(['spoke', 'circle']),
};

Spinner.defaultProps = {
  size: 40,
  color: 'black',
  type: 'spoke',
};

export * from './LoadingIndicator';
export { Spinner as default, Spinner };
